module.exports = __webpack_public_path__ + "static/media/icon-sidebar-video.877ad4ec.svg";